import { render, staticRenderFns } from "./Online99Fb2PrivateReply.vue?vue&type=template&id=aa60fc42&scoped=true&"
import script from "./Online99Fb2PrivateReply.vue?vue&type=script&lang=js&"
export * from "./Online99Fb2PrivateReply.vue?vue&type=script&lang=js&"
import style0 from "./Online99Fb2PrivateReply.vue?vue&type=style&index=0&id=aa60fc42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa60fc42",
  null
  
)

export default component.exports